import SwitchSelect from "features/bots/BotForm/common/SwitchSelect.tsx";
import React from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

import { LanguageNameSpaces } from "@shared/types";

interface FiltersOpenClosedSwitchProps {
  isOpen?: boolean;
  setIsOpen: (isOpen: boolean) => void;
  numOpen?: number;
  numClosed?: number;
}

const FiltersOpenClosedSwitch = ({
  isOpen,
  setIsOpen,
  numOpen,
  numClosed,
}: FiltersOpenClosedSwitchProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.TRADES);
  return (
    <SwitchSelect
      options={Object.values(Status)}
      selectedOption={isOpen ? Status.OPEN : Status.CLOSED}
      onClick={(value) => setIsOpen(value === Status.OPEN)}
      optionStyle={{ flex: "none" }}
      optionToDisplayName={{
        [Status.OPEN]: (
          <>
            {t("filters.status_open")}
            {numOpen !== undefined && ` (${numOpen})`}
          </>
        ),
        [Status.CLOSED]: (
          <>
            {t("filters.status_closed")}
            {numClosed !== undefined && ` (${numClosed})`}
          </>
        ),
      }}
      style={{ width: "max-content" }}
    />
  );
};

export default FiltersOpenClosedSwitch;

enum Status {
  OPEN = "Open",
  CLOSED = "Closed",
}
